// Hide/show an element from a Stimulus controller in a way that survives
// Bootstrap's display utilities.
//
// `el.style.display = "none"` and the `hidden` attribute BOTH lose to a
// `d-flex` / `d-block` utility on the same element: the utility is
// `display: … !important`, and Bootstrap's reboot `[hidden] { display: none
// !important }` is emitted BEFORE the utilities at equal specificity, so
// cascade order hands the win to `d-flex`. The Important Links rows carried
// `d-flex` and never disappeared while the search "worked" (#12284).
//
// `d-none` is the one display value Bootstrap emits AFTER every other display
// utility, so it out-ranks them at equal specificity. Toggle that, and read
// visibility back from the same class rather than from `style.display`.
export const HIDDEN_CLASS = "d-none"

export function setHidden(el, hidden) {
  el.classList.toggle(HIDDEN_CLASS, hidden)
}

export function isHidden(el) {
  return el.classList.contains(HIDDEN_CLASS)
}
